module.exports = __webpack_public_path__ + "img/niño75.fedcc82c.jpg";